import { css } from "@linaria/core"
import { styled } from "@linaria/react"
import { PopoverAnchor } from "@radix-ui/react-popover"

import { Horizontal, Vertical } from "@/components/Flex.ts"
import { PickerRegular } from "@/icons/Icons.ts"
import { ellipsis } from "@/styles/mixins.ts"
import * as textStyles from "@/styles/textStyles.ts"

import type { Property } from "csstype"

export const UserMessageMyMessageAnchor = css`
  left: 20px;
`

export const UserMessageOtherMessageAnchor = css`
  right: 20px;
`

export const UserMessagePopoverAnchor = styled(PopoverAnchor)`
  position: absolute;
  top: -12px;

  width: 0;
  height: 0;
`

export const UserMessageContainer = styled(Horizontal)<{
  isMyMessage?: boolean
  isActive?: boolean,
  isEditing?: boolean
}>`
  flex-direction: ${props => props.isMyMessage ? "row" : "row-reverse"};
  justify-content: flex-end;
  gap: 8px;

  transition: 0.2s opacity ease-in-out;
  opacity: ${props => props.isActive ? 1.0 : 0.5};

  margin-bottom: 24px;
`

export const UserMessageInner = styled(Vertical)<{ isEditing?: boolean }>`
  gap: 4px;

  max-width: 80%;

  flex-grow: ${props => props.isEditing ? 1.0 : 0.0};
`

export const StyledUserMessageBalloon = styled(Vertical)<{
  isMyMessage?: boolean
}>`
  position: relative;

  gap: 16px;

  overflow: hidden;

  padding: 16px 20px;

  border-radius: ${props => props.isMyMessage ? "24px 0 24px 24px" : "0 24px 24px 24px"};
  background: linear-gradient(180deg, var(--text-color-3), var(--text-color-2));
`

export const UserMessageType = styled.div`
  ${textStyles.smallestFontSize};

  text-align: right;

  color: var(--secondary-text-color);

  user-select: none;

  cursor: pointer;
`

export const UserMessageAvatarWrapper = styled.div`
  margin-top: 2px;
`

export const UserMessageContext = styled(Horizontal)`
  ${textStyles.smallFontSize};

  color: var(--text-color-60);
`

export const UserMessagePickerIcon = styled(PickerRegular)`
  width: 20px;
  height: 20px;
`

export const UserMessageUnknownAuthor = styled.span`
  ${ellipsis};
  ${textStyles.smallerFontSize};
  font-weight: 600;
`

export const CroppedMessageText = styled.div<{
  maxLines: number
  isExpanded: boolean
  fullHeight: number
  lineHeight: Property.LineHeight
}>`
  overflow: hidden;
  position: relative;

  transition: max-height 0.3s ease-in-out, mask-image 0.3s ease-in-out;

  max-height: ${props => props.isExpanded ? `${props.fullHeight}px` : `calc(${props.maxLines} * ${props.lineHeight})`};
  mask-image: ${props => props.isExpanded ? "none" : "linear-gradient(to bottom, black 60%, transparent 100%)"};
`

export const ShowMore = styled.a`
  ${textStyles.smallestFontSize};

  display: block;
  margin-top: -8px;
  padding: 4px 0;

  color: var(--secondary-text-color);
  font-weight: 400;

  user-select: none;

  &:hover {
    color: var(--text-color);
  }
`
